import Entity from './entity'
export default class Config extends Entity<number>{
    name: string;
    value: string;
}